<div class="col-xl-6 xl-100 box-col-12" style="width:340px !important">
  <div class="card" >
     
    <div class="job-search">
      <div class="card-body">
        <div class="d-flex">
          <div class="flex-grow-1">
            <h3 class="f-w-600">
              <a routerLink="/job-search/job-details" style="font-size:18px;">
                {{issueCard.title}}
              </a><span class="pull-right">Преди {{ daysAgo(issueCard.created.toString()) }} дни</span>

            </h3>
            <p>{{ issueCard.locationText }}</p>
            <ngb-rating [rate]="issueCard.severity" [readonly]="true" [max]="4"></ngb-rating>
          </div>
        </div> 
      </div>
    </div>
  </div>
</div>
